import { SFC, useEffect } from 'react';
import { withRouter } from 'react-router-dom';

const ScrollToTop: SFC<any> = ({ children, location: { pathname } }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return children || null;
};

export default withRouter(ScrollToTop);
